import { useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { WizardContextProps } from '../contexts';

export type FnVoid = () => void;

export type UseWizardProps = {
  totalSteps: number;
};

const useWizard = ({ totalSteps }: UseWizardProps): WizardContextProps => {
  const [activeStep, setActiveStep] = useState(1);
  const history = useHistory();

  const hasPrev = useMemo(() => {
    return activeStep > 1;
  }, [activeStep]);

  const hasNext = useMemo(() => {
    return activeStep < totalSteps;
  }, [activeStep, totalSteps]);

  const goPrev: FnVoid = () => {
    if (!hasPrev) {
      return;
    }

    const step = activeStep - 1;

    setActiveStep(step);
    history.push(`step${step}`);
  };

  const goNext: FnVoid = () => {
    if (!hasNext) {
      return;
    }

    const step = activeStep + 1;
    setActiveStep(step);
    history.push(`step${step}`);
  };

  return {
    totalSteps,
    activeStep,
    goPrev,
    goNext,
    hasPrev,
    hasNext,
  };
};

export { useWizard };
